module.exports = __webpack_public_path__ + "img/p6-p1-bg.6c474ced.jpg";